import { render, staticRenderFns } from "./PfStatementDownloadFormFront.vue?vue&type=template&id=6b9ad756"
import script from "./PfStatementDownloadFormFront.vue?vue&type=script&lang=js"
export * from "./PfStatementDownloadFormFront.vue?vue&type=script&lang=js"
import style0 from "./PfStatementDownloadFormFront.vue?vue&type=style&index=0&id=6b9ad756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports